import { useContext } from "react";
import { Link } from "react-router-dom";
import { LangContext } from '../../context/LangContext';
import useFormatText from "../../hooks/useFormatText";

import "./style.css"

import icon_fb from '../../assets/img/social-icon_fb.webp'
import icon_ytb from '../../assets/img/social-icon_ytb.webp'
import icon_insta from '../../assets/img/social-icon_insta.webp'
import icon_email from '../../assets/img/social-icon_email.webp'
import icon_threads from '../../assets/img/social-icon_threads.webp'
import icon_deviantart from '../../assets/img/social-icon_deviantart.webp'

function Footer() {
    const { language, translations } = useContext(LangContext);

    return (
        <footer>
            <p className="msg_prevention">
                {useFormatText(translations.msg_prevention_footer)}
            </p>

            <ul className="social_links">

                <li>
                    <a 
                        href='https://www.facebook.com/VanRah.Sama/' 
                        target='_blank' 
                        rel='noopener noreferrer'
                    >
                        <img src={icon_fb} alt="VanRah Facebook" />
                    </a>
                </li>

                <li>
                    <a 
                        href='https://www.instagram.com/vanrah.sama/?next=%2F' 
                        target='_blank' 
                        rel='noopener noreferrer'
                    >
                        <img src={icon_insta} alt="VanRah Instagram" />
                    </a>
                </li>

                <li>
                    <a 
                        href='https://www.youtube.com/@VanRah-Sama' 
                        target='_blank' 
                        rel='noopener noreferrer'
                    >
                        <img src={icon_ytb} alt="VanRah YouTube" />
                    </a>
                </li>

                <li>
                    <a 
                        href='https://www.deviantart.com/vanrah' 
                        target='_blank' 
                        rel='noopener noreferrer'
                    >
                        <img src={icon_deviantart} alt="VanRah DeviantArt" />
                    </a>
                </li>

                <li>
                    <a href='mailto:vanrah-tegamiden@outlook.com'>
                        <img src={icon_email} alt="Contact VanRah Email" />
                    </a>
                </li>

                <li>
                    <a 
                        href='https://www.threads.com/@vanrah.sama' 
                        target='_blank' 
                        rel='noopener noreferrer'
                    >
                        <img src={icon_threads} alt="VanRah Threads" />
                    </a>
                </li>

            </ul>

            <ul className="footer_nav">
                <li><Link to={`/${language}/legacy`}>{translations.link_legacy}</Link></li>
                <li><Link to={`/${language}/cgv`}>{translations.link_cgv}</Link></li>
                <li><Link to={`/${language}/rgpd`}>{translations.link_rgpd}</Link></li>

                <li className="e_mob"><Link to={`/${language}/copyright`}>{translations.link_copyright}</Link></li>
                <li className="e_mob"><Link to={`/${language}/cq`}>{translations.link_cq}</Link></li>
                <li className="e_mob"><Link to={`/${language}/fanart`}>{translations.link_fanart}</Link></li>
            </ul>

            <div className="copyright">
                <i className="logo_vanrah" />
                <p>
                    Copyright © 2026 VanRah. All rights reserved. <br />
                    Design by : VanRah <br />
                    Developed by : <a className="dev_link" href="mailto:corentin.beaudet14@gmail.com">C. Beaudet</a>
                </p>
                <i className="starBar"></i>
            </div>

            <ul className="footer_nav e_desk">
                <li><Link to={`/${language}/copyright`}>{translations.link_copyright}</Link></li>
                <li><Link to={`/${language}/cq`}>{translations.link_cq}</Link></li>
                <li><Link to={`/${language}/fanart`}>{translations.link_fanart}</Link></li>
            </ul>

        </footer>
    )
}

export default Footer;